<template>
  <b-notification :closable="false" class="validity-container">
    <h2 class="is-size-4 is-size-5-mobile">{{ $t('general.validity') }}</h2>
    <div v-html="compiledMarkdown"></div>
  </b-notification>
</template>

<script>
export default {
  name: 'Validity',
  props: {
    validity: String,
  },
  computed: {
    compiledMarkdown: function() {
      // eslint-disable-next-line
      return marked(this.validity, {sanitize: true})
    },
  },
}
</script>

<style scoped lang="scss">
.validity-container {
  margin-top: 2em;
  margin-bottom: 2em;
}
</style>
